import type { RouteObject } from 'react-router';

import * as searchInternshipsHorizonRouteExports from '#/modules/search/internships/page/SearchInternships.horizon-route';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

import { searchInternshipsRoutePaths } from './searchInternships.route-paths';

export const searchInternshipsRouteObjects = searchInternshipsRoutePaths.map(
  (path) => ({
    path,
    ...horizonRouteToObject(searchInternshipsHorizonRouteExports),
  }),
) satisfies RouteObject[];
